export enum OrderEntryEmailAssociationsMode {
    AllOrders,
    Manual
}